import { Box, Paper, Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import { FC } from 'react';
import EventActionButtons from './EventEditor/EventActionButtons';
import EventBasicInfoForm from './EventEditor/EventBasicInfoForm';
import EventConfigurationPanel from './EventEditor/EventConfigurationPanel';
import EventHeaderSection from './EventEditor/EventHeaderSection';
import EventSettingsSection from './EventEditor/EventSettingsSection';
import { useEventEditor } from './EventEditor/useEventEditor';

const EventDetailsEditor: FC<{ eventId: string, parentEventId: string | null }> = ({ eventId, parentEventId }) => {
    const {
        // State
        photoEvent,
        startDate,
        endDate,
        publicEventUrl,
        eventIsSubEvent,
        allEvents,
        allPricelists,

        // Handlers
        onSubmitEventDetails,
        onTitleChanged,
        onDatesChanged,
        onEventIsSubEventChanged,
        onParentEventChanged,
        onPricelistChanged,
        copyEventUrlToClipboard,
        getEventTitle,
        handleCancel,
        onIsPublicChanged,
        onIsExternalCopyrightChanged,
        onDisplayFreeOfChargeTextChanged,
        onIsFreeOfChargeChanged,
    } = useEventEditor(eventId, parentEventId);

    return (
        photoEvent !== undefined
            ? <Box sx={{ p: 3 }}>
                <EventHeaderSection
                    eventId={eventId}
                    publicEventUrl={publicEventUrl}
                    onCopyEventUrl={copyEventUrlToClipboard}
                />

                <form onSubmit={onSubmitEventDetails}>
                    <Grid container spacing={3}>
                        {/* Basic Information Section */}
                        <Grid size={{ xs: 12, lg: 8 }}>
                            <Paper elevation={2} sx={{ p: 3 }}>
                                <EventBasicInfoForm
                                    photoEvent={photoEvent}
                                    startDate={startDate}
                                    endDate={endDate}
                                    onTitleChanged={onTitleChanged}
                                    onDatesChanged={onDatesChanged}
                                />

                                <EventSettingsSection
                                    photoEvent={photoEvent}
                                    onDisplayFreeOfChargeTextChanged={onDisplayFreeOfChargeTextChanged}
                                    onIsExternalCopyrightChanged={onIsExternalCopyrightChanged}
                                    onIsFreeOfChargeChanged={onIsFreeOfChargeChanged}
                                    onIsPublicChanged={onIsPublicChanged}
                                />
                            </Paper>
                        </Grid>

                        {/* Configuration Section */}
                        <Grid size={{ xs: 12, lg: 4 }}>
                            <Paper elevation={2} sx={{ p: 3 }}>
                                <EventConfigurationPanel
                                    photoEvent={photoEvent}
                                    eventIsSubEvent={eventIsSubEvent}
                                    allEvents={allEvents}
                                    allPricelists={allPricelists}
                                    onEventIsSubEventChanged={onEventIsSubEventChanged}
                                    onParentEventChanged={onParentEventChanged}
                                    onPricelistChanged={onPricelistChanged}
                                    getEventTitle={getEventTitle}
                                />
                            </Paper>
                        </Grid>

                        {/* Action Buttons */}
                        <Grid size={12}>
                            <EventActionButtons
                                eventId={eventId}
                                onCancel={handleCancel}
                            />
                        </Grid>
                    </Grid>
                </form>
            </Box>
            : <Box sx={{ p: 3 }}>
                <Typography>Loading event details...</Typography>
            </Box>
    );
};

export default EventDetailsEditor;
